var reportModal = new Vue({
  el: '#contactModal',
  data: {
    reportForm: {
      errors: {
        email: [],
        name: [],
        phone: [],
        body: [],
      },
      inputs: {},
    },

    modalWindowStateShown: 'modal_shown',
  },
  methods: {
    submitReport: function(e) {
      const that = this,
        form = e.srcElement,
        action = form.action,
        $this = this,
        submit = $('#report_form_submit'),
        submitText = submit.text(),
        sendingText = submit.data('sending'),
        body = document.getElementsByTagName('body')[0],
        modalWindow = document.getElementById('contactModal');

      submit.text(sendingText);
      submit.prop('disabled', true);

      $.post(action, $(form).serialize(), 'json')
        .done(function(data) {

          submit.text(submitText);
          submit.prop('disabled', false);
          form.reset();

          window.location.href = data.url;
        })
        .fail(function(data) {
          submit.text(submitText);
          submit.prop('disabled', false);
          if (data.responseJSON.errors !== undefined) {
            $this.reportForm.errors = data.responseJSON.errors;
          }
        });

      return false;
    },
  },
});
